import React from "react";

export const Mars = () => {
  return (
    <div>
      <div
        id={"mars"}
        style={{
          frameborder: "0",
          width: "100%",
          height: "470px",
        }}
      ></div>
    </div>
  );
};
